import { defaultSessionSampleRate } from './const';
import { lazyLogDatapoint } from 'owa-analytics/lib/LazyAnalytics';
import { MinuteInfo } from 'owa-fps-types';
import UsageDatapoint from 'owa-analytics/lib/datapoints/UsageDatapoint';

export default function logAverageFpsPerMinute(data: MinuteInfo[], sampleRate?: number) {
    const customData = data.reduce(
        (acc, e, i) => ({
            ...acc,
            [`minute_${i}_fps`]: e.avgFps,
            [`minute_${i}_bg`]: e.wasTabInBackground,
        }),
        {}
    );
    const datapoint = new UsageDatapoint('client_fps', customData, {
        sessionSampleRate: sampleRate || defaultSessionSampleRate,
    });
    lazyLogDatapoint.importAndExecute(datapoint);
}
